export default __webpack_public_path__ + "static/media/foreign.9bd546d4.svg";